<div class="footer-wrapper">
    <footer id="footer" *ngIf="showFooter">
        <!-- Footer Menu-->
        <lazy-component
            class="footer-menu"
            [inputs]="{ showFooterMenu: showFooterMenu, footerMenuVisible: footerMenuVisible }"
            moduleUri="@lazy-modules-module/footerMenu/footer-menu.module#FooterMenuModule"
            entryComponent="FooterMenuComponent">
        </lazy-component>
        <!-- data-crlat="footerNotification" used for SSR -->
        <div class="footer-notification" *ngIf="isMobile && showBsBar" [ngClass]="{ hide: !showFooterMenu, hidden: !footerMenuVisible }">
            <!-- TODO  -->
            <lazy-component
                *ngIf="brand === 'ladbrokes'"
                moduleUri="@lazy-modules-module/betslipBar/betslip-bar.module#BetslipBarModule"
                entryComponent="LadbrokesBetslipNotificationComponent"
                [inputs]="{ hideNotification: hideNotification }"></lazy-component>

            <!-- TODO @@@@@@@@@@@@@ Commented for quacca bar testing @@@@@@@@@@@@ need to add condition to check Quacca bar availabilty and hide this -->
            <lazy-component
                *ngIf="brand === 'bma'"
                moduleUri="@lazy-modules-module/betslipBar/betslip-bar.module#BetslipBarModule"
                entryComponent="BetslipNotificationComponent"
                [inputs]="{ hideNotification: hideNotification }"></lazy-component>
        </div>
    </footer>
</div>
